import(/* webpackMode: "eager" */ "/build/src/app/template.tsx")